<template>
    <div>
        <base-header class="pb-6 pb-8 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

            <template v-if="loading">
                <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row">
                                <div class="flex justify-between" style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                                    <h3 class="mb-0">Categoria em Estoque</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-8">
                                            <base-input alternative=""
                                                label="Descritivo"
                                                input-classes="form-control-alternative"
                                                v-model="model.descritivo"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>


                                <input type="hidden" v-model="model.lab_id">

                                <input type="hidden" v-model="model.tipo">

                                <hr class="my-4" />

                                 <div class="pl-lg-4 text-right">

                                 <template v-if="loading2">
                                    <div class="m-2">
                                    <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                    </div>
                                </template>

                                <div  v-if="!loading2">
                                 <base-button
                                    type="default"
                                    @click="salvar()"
                                    v-html="txt1"
                                    ></base-button>
                                </div>
                            </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import estoque from '@/cflow/estoque-cat.js'
import storage from 'storage';
import router from '@/router'
import "vue-select/dist/vue-select.css";
  export default {
    name: 'tables',
    components: {
     // Multiselect,
      //BaseInput,
    },
    
    methods: {
        salvar: function() {

            this.loading = true;
            const _this = this;
            const _id = this.$route.params.id || '0';
            const form = this.model;

            estoque.salvar(_id, form).then(() => {
                _this.loading = false;
                router.push('/estoque-fornecedor');
                
            }).catch(() => {
                _this.loading = false;
                _this.hasError = true;
                 setTimeout(function(){
                    _this.hasError = false;
                },5000);
            });

           
        },

        detalhes: function(_id) {
            this.loading = true; 
            const _this = this;

            estoque.detalhes(_id).then(res => {
                _this.model = res;
                this.model.lab_id = res.id_lab;
                this.loading = false;
            }).catch((error) => {
                console.err('ERROR', error);
            });
        }
    },
    data() {
      return {
        txt1: 'Salvar',
        id: null,
        hasSuccess: false,
        hasError: false,
        loading: false,
        loading2: false,
        dated: '',
        model: {
          descritivo: '',
          tipo: 'FORNECEDOR',
          lab_id: 0
        }
      }
    },

     mounted(){

        const _id = this.$route.params.id || '';
        if(_id) {
            this.detalhes(_id);
        } else {
            let lab_id = 0;
            var user = storage.get("user");
            if(user.tipo == 'lab') lab_id = user.id;
            this.model.lab_id = lab_id;
        }

        
      

    }
  };
</script>
<style>
.height, .ProseMirror {
    min-height: 300px;
}
.select {
    width: 100%;
    padding: 5px 5px;
}
</style>
